(function() {
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function initSection(section) {
    if (section.getAttribute('data-custom-size-initialized') === 'true') return;
    section.setAttribute('data-custom-size-initialized', 'true');

    var typeHidden = qs('input[name="contact[Product type]"]', section);
    var typeButtons = qsa('[data-custom-size-type]', section);
    var colorOptions = qsa('[data-custom-size-pbn-options]', section);
    var stoneOptions = qsa('[data-custom-size-dp-options]', section);
    var widthInput = qs('[data-custom-size-width]', section);
    var heightInput = qs('[data-custom-size-height]', section);
    var sizeSummary = qs('[data-custom-size-summary]', section);
    var form = qs('form', section);
    var submitBtn = qs('.pbn-submit-btn', section);
    var feedback = qs('[data-custom-size-feedback]', section);
    var fileInputs = qsa('.pbn-file-input', section);
    var emptySummary = section.getAttribute('data-summary-empty') || 'Enter your width and height';
    var submitLoading = section.getAttribute('data-submit-loading') || 'Sending custom size request...';
    var pbnValue = section.getAttribute('data-pbn-value') || 'Paint By Numbers';
    var dpValue = section.getAttribute('data-dp-value') || 'Diamond Painting';
    var apiEndpoint = section.getAttribute('data-api-endpoint') || '';
    var successMessage = section.getAttribute('data-success-message') || 'Thank you. Your custom size request has been sent successfully.';

    function showFeedback(type, message) {
      if (!feedback) return;
      feedback.style.display = 'block';
      feedback.classList.toggle('pbn-feedback-success', type === 'success');
      feedback.classList.toggle('pbn-feedback-error', type === 'error');
      feedback.textContent = message;
    }

    function hideFeedback() {
      if (!feedback) return;
      feedback.style.display = 'none';
      feedback.classList.remove('pbn-feedback-success');
      feedback.classList.remove('pbn-feedback-error');
      feedback.textContent = '';
    }

    function setType(value) {
      if (typeHidden) typeHidden.value = value;

      typeButtons.forEach(function(btn) {
        btn.classList.toggle('pbn-pill-active', btn.getAttribute('data-custom-size-type') === value);
      });

      colorOptions.forEach(function(option) {
        option.style.display = value === pbnValue ? '' : 'none';
      });

      stoneOptions.forEach(function(option) {
        option.style.display = value === dpValue ? '' : 'none';
      });
    }

    function updateSummary() {
      if (!sizeSummary || !widthInput || !heightInput) return;

      var width = String(widthInput.value || '').trim();
      var height = String(heightInput.value || '').trim();
      sizeSummary.textContent = width && height ? width + ' x ' + height + ' cm' : emptySummary;
    }

    typeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setType(btn.getAttribute('data-custom-size-type'));
      });
    });

    [widthInput, heightInput].forEach(function(input) {
      if (input) input.addEventListener('input', updateSummary);
    });

    fileInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        var wrapper = input.closest('.pbn-upload-wrapper');
        var fileName = wrapper ? qs('[data-custom-size-file-name]', wrapper) : null;
        var emptyText = input.getAttribute('data-empty-file-text') || 'No file selected yet';
        var files = Array.prototype.slice.call(input.files || []);

        if (files.length > 0) {
          var label = files.length === 1 ? files[0].name : files.length + ' photos selected';
          if (fileName) fileName.textContent = label;
          if (wrapper) wrapper.classList.add('pbn-upload-has-file');
        } else {
          if (fileName) fileName.textContent = emptyText;
          if (wrapper) wrapper.classList.remove('pbn-upload-has-file');
        }
      });
    });

    if (form && submitBtn) {
      form.addEventListener('submit', function(event) {
        if (!apiEndpoint) return;

        event.preventDefault();
        if (!form.reportValidity()) return;

        hideFeedback();
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.7';
        submitBtn.style.cursor = 'default';
        var originalText = submitBtn.textContent;
        submitBtn.textContent = submitLoading;

        fetch(apiEndpoint, {
          method: 'POST',
          body: new FormData(form)
        }).then(function(res) {
          return res.json().catch(function() {
            return {};
          }).then(function(json) {
            if (!res.ok || !json.success) {
              throw new Error(json && json.error ? json.error : 'The custom size request could not be sent. Please try again.');
            }
            form.reset();
            updateSummary();
            setType(pbnValue);
            fileInputs.forEach(function(input) {
              input.dispatchEvent(new Event('change'));
            });
            showFeedback('success', successMessage);
          });
        }).catch(function(err) {
          showFeedback('error', err && err.message ? err.message : 'The custom size request could not be sent. Please try again.');
        }).finally(function() {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '';
          submitBtn.style.cursor = '';
          submitBtn.textContent = originalText;
        });
      });
    }

    setType(typeHidden && typeHidden.value ? typeHidden.value : pbnValue);
    updateSummary();
  }

  function init() {
    qsa('[data-custom-size-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event && event.target && event.target.matches('[data-custom-size-section]')) {
      initSection(event.target);
    }
  });
})();
